// extracted by mini-css-extract-plugin
export default {"step":"HomeSteps-HomeSteps__step--Cg9dk","descriptionWrapper":"HomeSteps-HomeSteps__descriptionWrapper--FiJha","descriptionText":"HomeSteps-HomeSteps__descriptionText--c3Upm"};